var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 109,
    viewBox: "0 0 107 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.91 108.95C73.1843 108.95 89.6199 107.925 89.6199 106.66C89.6199 105.395 73.1843 104.37 52.91 104.37C32.6356 104.37 16.2 105.395 16.2 106.66C16.2 107.925 32.6356 108.95 52.91 108.95Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.38 26.29C105.921 26.29 106.36 25.8512 106.36 25.31C106.36 24.7687 105.921 24.33 105.38 24.33C104.839 24.33 104.4 24.7687 104.4 25.31C104.4 25.8512 104.839 26.29 105.38 26.29Z",
    fill: "#0993DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1199 19.31C63.6611 19.31 64.0999 18.8712 64.0999 18.33C64.0999 17.7887 63.6611 17.35 63.1199 17.35C62.5786 17.35 62.1399 17.7887 62.1399 18.33C62.1399 18.8712 62.5786 19.31 63.1199 19.31Z",
    fill: "#0993DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 82.85V87.15",
    stroke: "#0799DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8298 85H26.1298",
    stroke: "#0799DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20996 1V5.3",
    stroke: "#0799DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0498 3.1499H10.3598",
    stroke: "#0799DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1599 23.1499V27.4599",
    stroke: "#0799DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0098 25.3099H88.3098",
    stroke: "#0799DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2399 80.73C51.8597 87.1887 58.8516 91.5523 66.6833 92.8645C74.5149 94.1766 82.5473 92.3302 89.0199 87.73C89.8199 87.1623 90.5908 86.5549 91.3299 85.91L103.26 89.52L98.6899 76.17C100.971 71.3947 101.949 66.1009 101.523 60.8258C101.097 55.5508 99.2839 50.4822 96.2666 46.1343C93.2494 41.7865 89.1356 38.3142 84.3429 36.0698C79.5502 33.8255 74.249 32.8888 68.9774 33.355C63.7057 33.8212 58.6512 35.6737 54.3268 38.7243C50.0023 41.775 46.5618 45.9153 44.3544 50.7252C42.147 55.5351 41.2512 60.8433 41.758 66.1112C42.2648 71.3791 44.1561 76.4192 47.2399 80.72V80.73Z",
    fill: "url(#paint0_linear_2003_2)",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4898 63.33C83.4898 64.1474 82.8272 64.81 82.0098 64.81C81.1924 64.81 80.5298 64.1474 80.5298 63.33C80.5298 62.5126 81.1924 61.85 82.0098 61.85C82.8272 61.85 83.4898 62.5126 83.4898 63.33Z",
    fill: "white",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.94 63.33C73.94 64.1474 73.2774 64.81 72.46 64.81C71.6426 64.81 70.98 64.1474 70.98 63.33C70.98 62.5126 71.6426 61.85 72.46 61.85C73.2774 61.85 73.94 62.5126 73.94 63.33Z",
    fill: "white",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3999 63.33C64.3999 64.1474 63.7373 64.81 62.9199 64.81C62.1026 64.81 61.4399 64.1474 61.4399 63.33C61.4399 62.5126 62.1026 61.85 62.9199 61.85C63.7373 61.85 64.3999 62.5126 64.3999 63.33Z",
    fill: "white",
    stroke: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.02 60.32C52.4003 66.7787 45.4083 71.1423 37.5767 72.4544C29.745 73.7666 21.7126 71.9202 15.24 67.32C14.4377 66.7554 13.6666 66.1479 12.93 65.5L1 69.13L5.57 55.77C3.28878 50.9947 2.31137 45.7009 2.73697 40.4258C3.16256 35.1507 4.97601 30.0821 7.99329 25.7343C11.0106 21.3865 15.1243 17.9142 19.917 15.6698C24.7098 13.4254 30.0109 12.4888 35.2826 12.955C40.5542 13.4212 45.6087 15.2736 49.9331 18.3243C54.2576 21.375 57.6981 25.5153 59.9055 30.3252C62.1129 35.1351 63.0087 40.4433 62.5019 45.7112C61.9952 50.979 60.1039 56.0191 57.02 60.32Z",
    fill: "url(#paint1_linear_2003_2)",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0999 48.7299C24.9872 47.231 26.2464 45.9866 27.7556 45.1169C29.2648 44.2473 30.973 43.7819 32.7147 43.7658C34.4565 43.7497 36.1729 44.1835 37.698 45.0251C39.223 45.8667 40.505 47.0877 41.4199 48.5699",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8798 38.53C44.8798 39.0326 44.4724 39.44 43.9698 39.44C43.4672 39.44 43.0598 39.0326 43.0598 38.53C43.0598 38.0274 43.4672 37.62 43.9698 37.62C44.4724 37.62 44.8798 38.0274 44.8798 38.53Z",
    fill: "white",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.54 38.53C22.54 39.0326 22.1326 39.44 21.63 39.44C21.1274 39.44 20.72 39.0326 20.72 38.53C20.72 38.0274 21.1274 37.62 21.63 37.62C22.1325 37.62 22.54 38.0274 22.54 38.53Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2003_2",
    x1: 72.44,
    y1: 33.2384,
    x2: 72.44,
    y2: 93.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2003_2",
    x1: 31.8199,
    y1: 12.8384,
    x2: 31.8199,
    y2: 72.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A8EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoComment);
export default __webpack_public_path__ + "static/media/no_comment.63f6ddb89631d623390287a1506b49d9.svg";
export { ForwardRef as ReactComponent };